import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';

const FontPropertySelect = ({ label, values, defaultValue, onChange }) => {
    return (
        <div className="col-xs-12 col-sm-4">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

const CardStylesColorSelect = ({ color, onColorChange }) => {
    return (
        <div className="col-xs-12 col-sm-2">
            <div className="row">
                <div className="col-xs-12 col-sm-8">
                    <PresetColorPicker color={color} onColorChange={onColorChange} />
                </div>
            </div>
        </div>
    );
};

class CardStyles extends Component {
    render() {
        return (
            <div className="CardStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-8">
                        <ReactSparkSelectInput
                            label="Font Family"
                            onChange={this.props.onFontChange(this.props.tagName)}
                            defaultValue={this.props.font}
                            values={this.props.availableFonts.map(v => {
                                return { key: v, label: v };
                            })}
                        />
                    </div>
                    <CardStylesColorSelect
                        color={this.props.color}
                        onColorChange={this.props.onFontColorChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Font Size"
                        defaultValue={this.props.fontData.size}
                        values={this.props.availableFontSizes}
                        onChange={this.props.onFontSizeChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Font Weight"
                        defaultValue={this.props.fontData.weight}
                        values={this.props.availableFontWeights[this.props.fontData.font]}
                        onChange={this.props.onFontWeightChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Font Style"
                        defaultValue={this.props.fontData.style}
                        values={this.props.availableFontStyle}
                        onChange={this.props.onFontStyleChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Text Align"
                        defaultValue={this.props.fontData.align}
                        values={this.props.availableTextAlign}
                        onChange={this.props.onTextAlignChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Text Decoration"
                        defaultValue={this.props.fontData.decoration}
                        values={this.props.availableTextDecoration}
                        onChange={this.props.onTextDecorationChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Line Height"
                        defaultValue={this.props.fontData.lineHeight}
                        values={this.props.availableLineHeight}
                        onChange={this.props.onLineHeightChange(this.props.tagName)}
                    />
                </div>
            </div>
        );
    }
}

CardStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.card[ownProps.tagName], ...state.theme.card };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_FONT,
                    layer: tagName,
                    font: event.target.value
                });
        },
        onFontSizeChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_FONT_SIZE,
                    layer: tagName,
                    size: event.target.value
                });
        },
        onFontWeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_FONT_WEIGHT,
                    layer: tagName,
                    weight: event.target.value
                });
        },
        onFontStyleChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_FONT_STYLE,
                    layer: tagName,
                    style: event.target.value
                });
        },
        onFontColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_FONT_COLOR,
                    layer: tagName,
                    color: event.target.value
                });
        },
        onTextAlignChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_TEXT_ALIGN,
                    layer: tagName,
                    align: event.target.value
                });
        },
        onTextDecorationChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_TEXT_DECORATION,
                    layer: tagName,
                    decoration: event.target.value
                });
        },
        onLineHeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_CARD_SET_THEME_LINE_HEIGHT,
                    layer: tagName,
                    lineHeight: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/card/Styles.js